import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * Resolve Phase 1 template-level "needs_human_review" from the reviewer
 * draft-source modal — triggers server-side bulk stamping and/or Phase 2
 * per-message AI review depending on draft mode.
 */
export function useTemplateComplianceResolveMutation(campaignId) {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const queryKey =
    user?.id && campaignId ? ['reviewerCampaign', user.id, campaignId] : null;

  return useMutation({
    mutationFn: async ({
      configId,
      resolution,
      note,
      overrideExistingVerdict = false,
    }) => {
      const { data } = await api.post(
        `/api/reviews/campaigns/${campaignId}/template-compliance/resolve`,
        {
          config_id: configId,
          resolution,
          note: note != null ? note : null,
          override_existing_verdict: overrideExistingVerdict,
        },
      );
      return data;
    },
    onSuccess: () => {
      if (!queryKey) return;
      // Resolve returns 202 and stamps in a background task. The compliance-tail
      // SSE usually updates the cache; if it cannot start, this refetch catches up.
      window.setTimeout(() => {
        void queryClient.invalidateQueries({ queryKey });
        void queryClient.refetchQueries({ queryKey, type: 'active' });
      }, 4000);
    },
    onSettled: () => {
      if (queryKey) {
        queryClient.invalidateQueries({ queryKey });
      }
    },
  });
}
